import React, {Component} from 'react'
import PropTypes from 'prop-types'
import moment from 'moment-timezone'

export class DateTimeDisplay extends Component {
  static defaultProps = {
    type: 'datetime'
  }

  static propTypes = {
    type: PropTypes.oneOf(['date', 'time', 'datetime'])
  }

  get value() {
    return this.props.value
  }

  get timezone() {
    return this.props.timezone || moment.tz.guess()
  }

  get showDate() {
    return this.props.type.toLowerCase().startsWith('date')
  }

  get showTime() {
    return this.props.type.toLowerCase().endsWith('time')
  }

  get singleLine() {
    return (this.props.singleLine || !(this.showDate && this.showTime))
  }

  render = () =>
    <span>
      {this.showDate && moment.tz(this.value, this.timezone).format('DD/MM/YYYY')} {!this.singleLine && <br/>}
      {this.showTime && moment.tz(this.value, this.timezone).format('HH:mm z')}
    </span>

}